<template>
    <div id="priceComparison" v-loading="loading"> <!-- 采购管理-订单管理-订单详情 -->
        <template>
            <!-- 头部订单信息 -->
            <div class="orderHead">
                <div class="content flex color-white">
                    <div class="b pl20">{{ detail.name }}</div>
                    <div class="f1 pl30">{{ detail.endTime }}截止</div>
                </div>
            </div>
            <!--内容-->
            <div class="background-white mt20 table-list content box-shadow">
                <!--表头操作-->
                <div class="watchBar">
                    <div class="color-blue left">
                        注意：请在任务时间范围内，填写商品报价信息并提交
                        <el-input size="small" style="width:200px" onfocus="this.removeAttribute('readonly')" autocomplete="off" class="text ml20 mr10" v-model.trim="keyWords" @keyup.enter.native="searchList" placeholder="请输入商品关键词"></el-input>
                        <el-select size="small" style="width: 200px;" placeholder="报价筛选，不选为全部" v-model="isOffer" clearable>
                                <el-option value="ALL" label="全部"></el-option>
                                <el-option :value="true" label="已报价"></el-option>
                                <el-option :value="false" label="未报价"></el-option>
                        </el-select>
                        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
                    </div>
                    <div class="btns right flex" v-show="isMobilePhone">
                        <a class="color-blue pointer" @click="downImportTemp">下载导入模板</a>
                        <div class="relative ml20">
                            <input @change="chagneUpload($event)" ref="file" type="file" name="file" id="file" class="el-upload__input absolute pointer">
                            <el-button size="small" class="export-right" type="primary" @click="importDialog=true">导入商品报价</el-button>
                        </div>
                    </div>
                </div>
                <div class="tab p">
                    <div class="flex table-header" style="width:100%">
                        <div style="width:50px;" >#</div>
                        <div style="width:100px;" class="pr10">客户货号</div>
                        <div style="width:120px;" class="pr10">我的货号</div>
                        <div class="f3 flex-wrap pr10">商品名称</div>
                        <div class="f2 flex-wrap pr10">规格</div>
                        <div class="f2 flex-wrap pr10">生产厂家</div>
                        <div class="f2 flex-wrap pr10">批准文号</div>
                        <div class="f2 flex-wrap pr10">计划采购量</div>
                        <div class="f2 flex-wrap pr10">价格</div>
                        <div class="f2 flex-wrap pr10">库存</div>
                        <div class="f2 flex-wrap pr10">有效期</div>
                    </div>
                    <ul class="table-body" style="width:100%">
                        <li v-for="(item,index) in dataList" :key="item.id" class="flex" style="width:100%" v-show="item.isShow">
                            <div style="width:50px;" class="pr10">{{(index+1)}}</div>
                            <div style="width:100px;" class="pr10">{{item.code}}</div>
                            <div style="width:120px;" class="pr10">
                                <div class="el-input el-input--small el-input--suffix">
                                    <input type="text" class="el-input__inner" autocomplete="new-password" maxlength="30"  v-model.trim="item.supplyCode" placeholder="我的货号"/>
                                </div>
                            </div>
                            <div class="f3 flex-wrap pr10">{{item.name}}</div>
                            <div class="f2 flex-wrap pr10">{{item.specifications}}</div>
                            <div class="f2 flex-wrap pr10">{{item.manufactur}}</div>
                            <div class="f2 flex-wrap pr10">{{item.licenseNumber}}</div>
                            <div class="f2 flex-wrap pr10">{{item.planQuantity}}</div>
                            <div class="f2 flex-wrap pr10">
                                <div class="el-input el-input--small el-input--suffix">
                                    <input type="text" class="el-input__inner" autocomplete="new-password" @blur="checkValidates(item,'price')"  v-model.trim="item.price" placeholder="请输入价格"/>
                                </div>
                            </div>
                            <div class="f2 flex-wrap pr10">
                                <div class="el-input el-input--small el-input--suffix">
                                    <input type="text" class="el-input__inner" autocomplete="new-password" maxlength="8" size="small" @blur="checkValidates(item,'stock')" v-model.trim="item.stock" placeholder="请输入库存" />
                                </div>
                            </div>
                            <div class="f2 flex-wrap pr10">
                                <input type="date" class="expire-time" v-model="item.expireTime"/>
                                <!-- <el-date-picker class="noborder" style="width:100%" v-model="item.expireTime" size="small" type="date" placeholder="请选择"></el-date-picker> -->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 底部按钮 -->
            <div class="submit box-shadow background-white">
                <div class="content">
                    <div class="btn right text-center color-white fontSize18 pointer" @click="submitOfferDialog = true">提交报价</div>
                </div>
            </div>
        </template>

        <!-- 导入商品报价 -->
        <el-dialog title="导入商品报价" :visible.sync="importDialog" :close-on-click-modal="false" width="700px" :destroy-on-close="true">
            <div class="import_content flex">
                <div class="f1 relative">
                    <template v-if="!isImporting">
                        <input @change="chagneUpload($event)" ref="file" type="file" name="file" id="file" class="el-upload__input absolute pointer">
                        <el-button size="small" class="mr30" type="primary">导入表格</el-button>
                    </template>
                    <template v-else>
                        <p class="color-909399">已选择文件：{{fileName||''}}</p>
                        <div class="flex mt10 mb15">
                            <el-button size="small" class="mr30" type="primary" @click="importTemplate">确认上传</el-button>
                            <div class="relative ml20">
                                <el-button size="small" type="primary" plain>重新上传</el-button>
                                <input @change="chagneUpload($event)" ref="file" type="file" name="file" id="file2" class="el-upload__input absolute pointer">
                            </div>
                        </div>
                        <div v-if="fileCountTime" class="color-blue">
                            上传成功 {{ fileCountTime }} 秒后自动关闭
                        </div>
                        <!-- <el-progress :text-inside="true" :stroke-width="24" @format="percentage" :percentage="70"></el-progress> -->
                    </template>
                </div>
                <div class="right pointer mt5" >
                    <a class="color-blue" href="https://priceoss.yuncai998.com/templates/线下比价导入商品模板.xls" download="线下比价导出模板">下载导入模板</a>
                </div>
                <div class="clear"></div>
            </div>
            <div class="matters-needing mt20 mb20">
                <p class="color-9 mt5">注意事项：</p>
                <p class="color-909399">1、商品名称、规格、生产厂家必填，用于商品识别</p>
                <p class="color-909399">2、价格小数点前最多输入8位数，小数点后最多输入两位数</p>
                <p class="color-909399">3、价格、库存、有效期都可以为空</p>
                <p class="color-909399">4、每次导入商品最多3000条</p>
            </div>
        </el-dialog>

        <!-- 数据匹配确认 -->
        <el-dialog title="数据匹配确认" :visible.sync="compareDataDialog" :close-on-click-modal="false" width="560px" :destroy-on-close="true" class="compare-data">
            <div class="text-center">
                <p>选择以下数据在导入的excel中对应的表头名称，*号为必选</p>
                <p class="color-red">若选择项中缺少导入数据，请下载导入模板重新导入</p>
            </div>
            <div class="matters-needing mt20 mb20">
                <el-form :model="compareDataParam" ref="compareRuleForm" :rules="compareRuleForm" label-width="110px" class="demo-addRuleForm">
                    <el-form-item label="我的货号">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.code">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="name">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.name">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="规格" prop="specifications">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.specifications">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生产厂家" prop="manufactur">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.manufactur">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="批准文号">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.licenseNumber">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.price">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.stock">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="有效期">
                        <el-select size="small" class="select" placeholder="请选择" v-model="compareDataParam.expireTime">
                            <el-option label="请选择" value=""></el-option>
                            <el-option :label="item" :value="item" v-for="item in headerList" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <div class="color-98">
                            <div style="line-height:22px;">注意事项：</div>
                            <div style="line-height:22px;">1、价格小数点前最多输入8位数，小数点后最多输入2位数</div>
                            <div style="line-height:22px;">2、每次导入商品最多3000条</div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="confirmImport">&emsp;确认导入&emsp;</el-button>
                        <el-button type="primary" plain @click="compareDataDialog=!compareDataDialog">&emsp;取消&emsp;</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

        <!-- 提交商品报价 -->
        <el-dialog title="提交商品报价" v-loading="loading" :visible.sync="submitOfferDialog" :close-on-click-modal="false" width="550px" :destroy-on-close="true">
            <el-form :model="submitParam" ref="addRuleForm" :rules="rules" label-width="110px" class="demo-addRuleForm">
                <el-form-item label="报价公司" prop="name">
                    <el-input placeholder="请输入公司，30字之内" maxlength="30" v-model.trim="submitParam.name" class="width360"></el-input>
                    <div class="color-909399">若该公司的报价信息已提交过，将会覆盖</div>
                </el-form-item>
                <el-form-item label="报价人" prop="liaisonMan">
                    <el-input placeholder="请输入报价人，15字之内" maxlength="15" v-model.trim="submitParam.liaisonMan" class="width360"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="telephone">
                    <el-input placeholder="请输入联系电话，15字之内" maxlength="15" v-model.trim="submitParam.telephone" class="width360"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="mt20" type="primary" plain @click="submitOfferDialog=!submitOfferDialog">&emsp;取消&emsp;</el-button>
                    <el-button class="mt20" type="primary" @click="submitOffer">&emsp;保存&emsp;</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import XLSX from 'xlsx'
export default {
    name: 'priceComparison', // 线下比价
    data () {
        var telephone = (rule, value, callback) => {
			var reg = /^\d+$|^\d+[.]?\d+$/; //判断是否输入数字
			if(!reg.test(value)){
				callback(new Error('连接必须带有协议，正确连接格式如(https://www.baidu.com)'));
            }else {
				callback();
			}
		};
        return {
            taskId: null, //连接上带过来的参数
            detail: {}, //任务详情
            oldData:[],
            dataList: [],
            totalCount: 0,
            loading: false,
            load: false, //是否显示页面内容
            importDialog: false, //导入弹窗
            isImporting: false, //是否正在导入
            fileDom: '',
            fileName: '', //文件名称
            fileCountTime: null, //导入成功倒计时
            submitOfferDialog: false, //提交商品报价弹窗
            submitParam: {
                name: '', //报价公司
                liaisonMan: '', //报价人
                telephone: '', //报价电话
            }, //提交报价参数
            defaultSubmitParam: {
                name: '', //报价公司
                liaisonMan: '', //报价人
                telephone: '', //报价电话
            }, //初始报价参数
            rules: {
                name:[{required: true, message: '请输入报价公司', trigger: 'blur'}],
                liaisonMan:[
                    {required: true, message: '请输入报价人', trigger: 'blur'}
                ],
                telephone:[
                    {required: true, message: '请输入联系电话', trigger: 'blur'},

                ]
            },
            passwordDialog: false,
            password: '', //弹窗密码
            isMobilePhone: false, //是否是手机浏览器
            arrLength: 300, //每次渲染列表的条数
            initCount: 0, //第几次追加列表
            dom: "", //表格对象
            downUrlHost: '',
            keyWords: '', //搜索关键字
            isOffer: '', // 是否报价
            compareDataDialog: false, //数据比对弹窗
            headerList: [], //excel表的表头
            compareDataParam: {
                code: '', //我的货号
                name: '', //名称
                specifications: '', //规格
                manufactur: '', //厂家
                licenseNumber: '', //批准文号
                price: '',
                stock:'',
                expireTime: ''
            },
            compareRuleForm: {
                name:[{required: true, message: '请选择商品名称', trigger: 'change'}],
                specifications:[{required: true, message: '请选择规格', trigger: 'change'}],
                manufactur:[{required: true, message: '请选择生产厂家', trigger: 'change'}],
            },
            uuid: ''
        }
    },
    watch: {
        submitOfferDialog (val) {
            if (!val) {
                this.submitParam = {...this.defaultSubmitParam};
                this.$refs.addRuleForm.resetFields()
            }
        },
        compareDataDialog (val) {
            if (!val){
                this.$refs.file.value = '';
                this.fileDom = null;
            }
        }
    },
    methods: {
        checkValidates (val,key) {//检测子商品输入参数
            if(key === 'price'){
                //价格，最多两位小数
                var reg = /^[0-9]{1,8}([.][0-9]{1,2})?$/;
                if (val[key] && !reg.test(+val[key])) {
                    this.$message.error('小数点前最多输入8位数，小数点后最多输入2位数!');
                    val[key] = null
                }
            } else if(key === 'stock') {
                //库存限制允许有小数点
                var reg = /^[0-9]{1,8}([.][0-9]{1,3})?$/;
                if (val.stock && !reg.test(val.stock) || val.stock>99999999){
                    console.log('val.stock',val.stock);
                    this.$message.error('小数点前最多输入8位数，小数点后最多输入3位数!');
                    val.stock = null;
                }
            }
            var index = 0;
            this.dataList.forEach((list,idx)=>{
                if (list.id == val.id) {
                    index = idx;
                }
            });
            this.$set(this.dataList,index,val);
        },
        // 下载导入模板
        downTemplate () {
            const loading = this.load();
            this.$http('POST', '/admin/recommend/platformt/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                    if (res.status === '200') {
                        this.educe(res.data);
                    }
                }
            })
        },
        //导入表格
        chagneUpload (dom) {
            let reg = /^.*\.(?:xls|xlsx)$/i;
            if (!!dom.target.files) {
                let file = dom.target.files[0];
				if (!reg.test(file.name)) {
					this.$message.error('请上传以.xls或xlsx结尾的文件!');
					return false;
				}
                this.fileDom = file;
                this.fileName = file.name;
                this.isImporting = true
                //获取表头
                const isLt5M = file.size/1024/1024 < 5;
                const extention = file.name.split('.').slice(-1)[0] === 'xls';
                const extention2 = file.name.split('.').slice(-1)[0] === 'xlsx';
                if (!extention && !extention2) {
                    this.$message.warning('长传的文件只能是Excel')
                    return false
                }
                if (!isLt5M) {
                    this.$message.warning('文件大小不能超过5MB')
                    return false
                }
                let that = this
                var reader = new FileReader();
                reader.onload = ev => {
                    try {
                        const data = ev.target.result;
                        const workbook = XLSX.read(data, {
                            type: "binary", // 以字符编码的方式解析
                            cellDates: true
                        });
                        const exlname = workbook.SheetNames[0]; // 取第一张表
                        console.log('exlname',exlname,workbook.Sheets[exlname]);
                        let excelHeader = workbook.Sheets[exlname]
                        this.headerList = []
                        for (var key in excelHeader){
                            if (key !== '!margins' && key !== '!ref') {
                                if (key.length === 2) {
                                    let key1 = key.slice(1,2); //只要表头，所以只要前面的行数为1的key
                                    if (key1 < 2) {
                                        if (!this.headerList.includes(excelHeader[key].v)) {
                                            this.headerList.push(excelHeader[key].v) //表头不用重复
                                        } else {
                                            throw new Error ("导入表头名称不能重复或格式错误")
                                        }
                                    }
                                }
                            }
                        }
                        if (this.headerList.length <= 0) {
                            throw new Error ("导入表头名称不能重复或格式错误")
                        }
                        if (this.headerList.includes('商品编码')) {
                            this.compareDataParam.code = '商品编码'
                        } else if (this.headerList.includes('货号')) {
                            this.compareDataParam.code = '货号'
                        } else if (this.headerList.includes('编码')) {
                            this.compareDataParam.code = '编码'
                        } else {
                            this.compareDataParam.code = ''
                        }

                        if (this.headerList.includes('商品名称')) {
                            this.compareDataParam.name = '商品名称'
                        } else if (this.headerList.includes('品名')) {
                            this.compareDataParam.name = '品名'
                        } else if (this.headerList.includes('用名称')) {
                            this.compareDataParam.name = '用名称'
                        } else if (this.headerList.includes('商品')) {
                            this.compareDataParam.name = '商品'
                        } else if (this.headerList.includes('药品')) {
                            this.compareDataParam.name = '药品'
                        } else if (this.headerList.includes('名称')) {
                            this.compareDataParam.name = '名称'
                        } else {
                            this.compareDataParam.name = ''
                        }

                        if (this.headerList.includes('规格')) {
                            this.compareDataParam.specifications = '规格'
                        } else if (this.headerList.includes('型号')) {
                            this.compareDataParam.specifications = '型号'
                        } else {
                             this.compareDataParam.specifications = ''
                        }

                        if (this.headerList.includes('生产厂家')) {
                            this.compareDataParam.manufactur = '生产厂家'
                        } else if (this.headerList.includes('生产企业')) {
                            this.compareDataParam.manufactur = '生产企业'
                        } else if (this.headerList.includes('生产厂')) {
                            this.compareDataParam.manufactur = '生产厂'
                        } else if (this.headerList.includes('生产单位')) {
                            this.compareDataParam.manufactur = '生产单位'
                        } else if (this.headerList.includes('厂家')) {
                            this.compareDataParam.manufactur = '厂家'
                        } else if (this.headerList.includes('厂牌')) {
                            this.compareDataParam.manufactur = '厂牌'
                        } else {
                            this.compareDataParam.manufactur = ''
                        }

                        if (this.headerList.includes('批准')) {
                            this.compareDataParam.licenseNumber = '批准'
                        } else if (this.headerList.includes('文号')) {
                            this.compareDataParam.licenseNumber = '文号'
                        } else {
                             this.compareDataParam.licenseNumber = ''
                        }

                        if (this.headerList.includes('采购量')) {
                            this.compareDataParam.stock = '采购量'
                        } else if (this.headerList.includes('入库数量')) {
                            this.compareDataParam.stock = '入库数量'
                        } else if (this.headerList.includes('缺货数')) {
                            this.compareDataParam.stock = '缺货数'
                        } else {
                             this.compareDataParam.stock = ''
                        }

                        if (this.headerList.includes('采购价')) {
                            this.compareDataParam.price = '采购价'
                        } else if (this.headerList.includes('批发价')) {
                            this.compareDataParam.price = '批发价'
                        } else if (this.headerList.includes('进货价')) {
                            this.compareDataParam.price = '进货价'
                        } else if (this.headerList.includes('入库价')) {
                            this.compareDataParam.price = '入库价'
                        } else if (this.headerList.includes('来货价')) {
                            this.compareDataParam.price = '来货价'
                        } else if (this.headerList.includes('供货价')) {
                            this.compareDataParam.price = '供货价'
                        } else if (this.headerList.includes('报价')) {
                            this.compareDataParam.price = '报价'
                        } else if (this.headerList.includes('价格')) {
                            this.compareDataParam.price = '价格'
                        }  else if (this.headerList.includes('成本价')) {
                            this.compareDataParam.price = '成本价'
                        }  else {
                            this.compareDataParam.price = ''
                        } //优化需求980（根据这些表头判断，有先后顺序）
                        // this.compareDataParam.code = (this.headerList.includes('我的货号')?'我的货号':'')
                        // this.compareDataParam.name = (this.headerList.includes('商品名称')?'商品名称':'')
                        // this.compareDataParam.specifications = (this.headerList.includes('规格')?'规格':'')
                        // this.compareDataParam.manufactur = (this.headerList.includes('生产厂家')?'生产厂家':'')
                        // this.compareDataParam.licenseNumber = (this.headerList.includes('批准文号')?'批准文号':'')
                        // this.compareDataParam.price = (this.headerList.includes('价格')?'价格':'')
                        // this.compareDataParam.stock = (this.headerList.includes('库存')?'库存':'')
                        this.compareDataParam.expireTime = (this.headerList.includes('有效期')?'有效期':'')
                        let exl = XLSX.utils.sheet_to_json(excelHeader); // 生成json表格内容包含了表格内容，不只是表头
                        this.compareDataDialog = true;
                    } catch (e) {
                        that.$message.error(e.message);
                        return false;
                    }
                };
                reader.readAsBinaryString(file);
			}
        },
        //确认导入
        confirmImport () {
            if (!this.compareDataParam.name) {
                this.$alert('请选择商品名称', '提示')
                return false
            }
            if (!this.compareDataParam.specifications) {
                this.$alert('请选择规格', '提示')
                return false
            }
            if (!this.compareDataParam.manufactur) {
                this.$alert('请选择厂家', '提示')
                return false
            }
            this.importTemplate()
        },
        //生成唯一UUID值
        generateUUID () {
            return (Math.round(Math.random()*10)).toString() + (2+Math.round(Math.random())*5).toString() +(Math.round(Math.random())*8).toString() +(Math.round(Math.random())*6).toString()
        },
        //上传文件
        importTemplate () {
            if (!this.fileDom) {
                this.$message.error('请选择文件');
                return false;
            }
            let refList = []
            for (let key in this.compareDataParam) {
                let keyName = ''
                switch (key) {
                    case 'code':
                        keyName = '商品编码'
                        break;
                    case 'name':
                        keyName = '商品名称'
                        break;
                    case 'specifications':
                        keyName = '规格'
                        break;
                    case 'manufactur':
                        keyName = '生产厂家'
                        break;
                    case 'licenseNumber':
                        keyName = '批准文号'
                        break;
                    case 'price':
                        keyName = '价格'
                        break;
                    case 'stock':
                        keyName = '库存'
                        break;
                    case 'expireTime':
                        keyName = '有效期'
                        break;
                }
                let param = {key: keyName, value: this.compareDataParam[key]}
                refList.push(param)
            }
            let formData = new FormData();
            formData.append('taskId', this.taskId)
            this.uuid = Number(this.generateUUID())
            formData.append('uuid', this.uuid) //生成唯一标识,只能是number
            formData.append('file',this.fileDom);
            formData.append('refList',JSON.stringify(this.compareDataParam))
            this.loading = true;
            this.compareDataDialog = false; //关闭弹窗
            this.$http('post', '/company/offline/task/importProduct',{},formData, (status, res) => {
                console.log('status, res',status, res);
                this.loading = false;
                if (status) {
                    if (res.data && res.data.length>0) {
                        this.success(res.message);
                        var priceReg = /^[0-9]{1,8}([.][0-9]{1,2})?$/;
                        var stockReg = /^[0-9]{1,8}([.][0-9]{1,3})?$/;
                        res.data.forEach((item)=>{
                            this.dataList.forEach((el)=>{
                                if (item.id === el.id) {
                                    if (item.price) {
                                        if (priceReg.test(item.price)) {
                                            el.price = item.price
                                        }
                                    } else {
                                        el.price = null
                                    }
                                    if (item.stock) {
                                        if (stockReg.test(item.stock) && item.stock<=99999999) {
                                            el.stock = item.stock
                                        }
                                    } else {
                                        el.stock = null
                                    }
                                    if (item.expireTime) {
                                        el.expireTime = (this.moment(item.expireTime).format('YYYY-MM-DD')|| null)
                                    } else {
                                        el.expireTime = null
                                    }
                                    if (item.supplyCode) {
                                        if (item.supplyCode.length>30) {
                                            el.supplyCode = null
                                        } else {
                                            el.supplyCode = item.supplyCode
                                        }
                                    } else {
                                        el.supplyCode = null
                                    }
                                }
                            })
                        })
                        this.update();//数据强制刷新
                        this.$refs.file.value = '';
                        this.fileDom = null;
                    } else{
                        this.$refs.file.value = '';
                        this.fileDom = null;
                        this.isImporting = false;
                        this.$message.error('导入条数为0，请检查表格后重新上传')
                    }
                }
            });
        },
        //提交报价
        submitOffer () {
            this.$refs.addRuleForm.validate( (check) => {
                if (check) {
                    let options = {...this.submitParam}
                    options.taskId = this.taskId
                    options.productList = [...this.dataList]; //商品列表
                    options.uuid = this.uuid
                    this.loading = true
                    this.$http('post', '/company/offline/task/submit', {}, options, (status, rsp) => {
                        this.loading = false
                        if (status) {
                            this.success('报价信息提交成功，请耐心等待答复', '任务提示')
                            this.submitOfferDialog = false;
                        }
                    })
                }
            })
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        //获取连接上的参数
        getURLparam (name) {
            let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
            let result  = window.location.search.substr(1).match(reg);
            return result ? decodeURIComponent(result[2]) : null;
        },
        getDataList() {
            let options = {
                taskId: this.taskId
            }
            this.loading = true
            this.$http('post', '/company/offline/task/get', {}, options, (status, rsp) => {
                this.loading = false
                if (status) {
                    rsp.data.productList.forEach((item)=>{
                        item.price = null;
                        item.stock = null;
                        item.expireTime = null;
                        item.isShow = true;
                    })
                    this.detail.name = rsp.data.name
                    this.detail.endTime = rsp.data.endTime
                    this.detail.accessPassword = rsp.data.accessPassword //随访密码
                    this.dataList = rsp.data.productList //任务商品列表
                }
            })
        },
        //判断密码是否输入正确
        confirmPassword () {
            let count = Math.ceil(this.oldData.length/this.arrLength)
            if (this.initCount <= count) {
                let arr = this.oldData.slice((this.initCount*this.arrLength),(this.initCount*this.arrLength+this.arrLength))
                for(let i=0; i< arr.length; i++){
                    this.dataList.push(arr[i])
                }
            }
        },
        //检测浏览器
        browserRedirect () {
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
                this.isMobilePhone = true
            }
        },
        //表格滚动
        tableScroll (){
            this.$nextTick(()=>{
                this.dom = this.$refs.table.bodyWrapper
                this.dom.addEventListener('scroll', () => {
                    // 滚动距离
                    let scrollTop = this.dom.scrollTop
                    // 变量windowHeight是可视区的高度
                    let windowHeight = this.dom.clientHeight || this.dom.clientHeight
                    // 变量scrollHeight是滚动条的总高度
                    let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight
                    if (scrollTop + windowHeight === scrollHeight) {
                        // 获取到的不是全部数据 当滚动到底部 继续获取新的数据
                        console.log('scrollTop', scrollTop + 'windowHeight', windowHeight + 'scrollHeight', scrollHeight)
                        this.initCount++
                        this.confirmPassword()
                    }
                })
            })
        },
        //关键字搜索
        searchList () {
            // console.log('this.keyword',this.keyWords);
            if (this.keyWords || (this.isOffer !== 'ALL' && this.isOffer !== '')) {
                this.dataList.some(el => {
                    el.isShow = false
                    let key = () => {
                        if (this.keyWords) {
                            if ((el.name.indexOf(this.keyWords) !== -1 || el.manufactur.indexOf(this.keyWords) !== -1 || ('' + el.licenseNumber).indexOf(this.keyWords) !== -1)) {
                                return true
                            } else {
                                return false
                            }
                        }
                        return true
                    }
                    let price = () => {
                        if (this.isOffer === true) {
                            return (el.price ? true : false)
                        }
                        if (this.isOffer === false) {
                            return (el.price ? false : true)
                        }
                        return true
                    }
                    if (key() && price()) {
                        el.isShow = true
                    }
                })
            } else {
                this.dataList.forEach(el => {
                    el.isShow = true
                })
            }
            // this.update()
        },
        //下载导出模板
        downImportTemp () {
            let options = {
                taskId: this.taskId
            }
            this.loading = true
            this.$http('post', '/company/offline/task/export', {}, options, (status, rsp) => {
                this.loading = false
                if (status) {
                    this.educe(rsp.data)
                }
            })
        }
    },
    mounted () {
        this.taskId = this.getURLparam('taskId');
        this.browserRedirect()
        if (this.taskId) {
            let options = {
                taskId: this.taskId
            }
            this.loading = true
            this.$http('post', '/company/offline/task/get', {}, options, (status, rsp) => {
                let nowTime = new Date()
                this.dataList = [];
                if (status && rsp.data) {
                    if (this.moment(rsp.data.endTime, 'YYYY-MM-DD HH:mm:ss').valueOf() < nowTime.getTime() ) {
                        this.$alert('抱歉，当前报价已经结束，客户已经选择到合适的产品，请下次积极报价，争取成交', '任务提示', {
                            showClose: false,
                            showConfirmButton: false
                        })
                    } else {
                        rsp.data.productList.forEach((item)=>{
                            item.price = null;
                            item.stock = null;
                            item.expireTime = null;
                            item.supplyCode = null
                            item.isShow = true
                        })
                        this.detail.name = rsp.data.name
                        this.detail.endTime = rsp.data.endTime
                        this.detail.accessPassword = rsp.data.accessPassword //随访密码
                        const that = this
                        if (this.detail.accessPassword) {
                            this.$prompt('请输入访问密码', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                showCancelButton: false,
                                showClose: false,
                                closeOnClickModal: false,
                                inputType: 'password',
                                beforeClose (action, instance, done) {
                                    if (instance.inputValue === that.detail.accessPassword) {
                                        that.load = true
                                        done()
                                    } else {
                                        this.$message.error('密码错误，请重新输入')
                                    }
                                }
                            }).then(()=>{
                                this.dataList = rsp.data.productList //任务商品列表
                                this.loading = false
                            }).catch(() => {
                                //取消或者关闭时的操作
                            });
                        } else {
                            this.loading = false
                            this.load = true
                            this.dataList = rsp.data.productList //任务商品列表
                            //处理数据
                            // this.confirmPassword()
                            // that.tableScroll()
                        }
                    }
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#priceComparison{width: 100%;height: 100vh;overflow-y: auto;}
#priceComparison .content{margin-left: auto; margin-right: auto;}
#priceComparison .orderHead{width: 100%; background: #2979FF; height: 58px; line-height: 58px;}
.box-shadow{box-shadow: 0 0 5px 0 #e3e3e3;}
#file,#file2{display: block; top: 0; left: 0; width: 104px; height: 30px; z-index: 5; opacity: 0; cursor: pointer;}
#priceComparison .table-list{height: calc(100% - 150px);}
#priceComparison .table-list .tab{height: calc(100% - 70px);}

#priceComparison .table-list .tab .table-header{padding: 10px; border-bottom:1px solid #ebeef5; color: #606266; font-weight: bold;}
#priceComparison .table-list .tab .table-body{height: calc(100% - 50px); overflow: auto; padding: 10px;}
#priceComparison .table-list .tab .table-body li{padding: 6px 0; border-bottom:1px solid #ebeef5; color: #606266;}
#priceComparison .table-list .tab .table-body li .expire-time{width: 90%;height: 30px;line-height: 30px; border-radius: 2px; border: 1px solid #DCDFE6; color: #606266;}
#priceComparison .table-list .tab .table-body::-webkit-scrollbar{width: 5px;}
#priceComparison .table-list .tab .table-body::-webkit-scrollbar-thumb { border-radius: 5px;  width: 6px; background: #b4bccc;}
.width360{width: 360px;}
#priceComparison .submit{width: 100%; height: 60px;}
#priceComparison .submit .btn{height: 60px; line-height: 60px; background: #2480ED; width: 168px;}
#priceComparison .submit .btn:hover{opacity: .8;}
.compare-data >>>.el-dialog__body{padding: 0 20px 10px;}
.compare-data >>>.el-dialog__body .el-form-item{margin-bottom: 12px;}

</style>



// WEBPACK FOOTER //
// src/views/priceComparison.vue